/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-13 13:56:13
 * @LastEditTime: 2020-08-13 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/service/domainService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";
/**
 * Domain列表
 */
export function getDomainData(Info) {
  return request({
    url:
      "/api/v1/domains?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}
/*
 * 新建Domain页面数据
 */
export function createDomain(data) {
  return request({
    url: "/api/v1/domains",
    method: "POST",
    data: data
  });
}
/*
 * 编辑Domain页面数据
 */
export function editDomain(data) {
  return request({
    url: "/api/v1/domains/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
/*
 * 获取Domain数据详情
 */
export function getDomainInfo(id) {
  return request({
    url: "/api/v1/domains/" + id,
    method: "GET"
  });
}
/*
 * 删除Domain数据
 */
export function deleteDomain(id) {
  return request({
    url: "/api/v1/domains/" + id,
    method: "DELETE"
  });
}



// WEBPACK FOOTER //
// ./src/service/domainService.js